import { graphql } from '@shared/types/storefront'

graphql(/* GraphQL */ `
  fragment CartDiscountCode on CartDiscountCode {
    applicable
    code
  }
`)

graphql(/* GraphQL */ `
  fragment CartDiscountAllocation on CartDiscountAllocation {
    discountedAmount {
      amount
      currencyCode
    }
  }
`)

export const updateCartDiscountCodeMutation = graphql(/* GraphQL */ `
  mutation updateCartDiscountCode(
    $cartId: ID!
    $discountCodes: [String!]
    $country: CountryCode
    $language: LanguageCode
  ) @inContext(country: $country, language: $language) {
    cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
      cart {
        ...Cart
      }
      userErrors {
        code
        field
        message
      }
      warnings {
        ...CartWarning
      }
    }
  }
`)
